import { WaiveApprovalStatus } from "../../../graphql/generated";
import { toHumanReadable } from "../../../utils/string";

export const approvalStatusOptions = Object.values(WaiveApprovalStatus).map(
  (value) => {
    return { value, label: toHumanReadable(value) };
  }
);
